const LBS_VALUE = 0.45359237;
const KG_VALUE = 2.2046226218487757;

export const kgToLbs = (biomass: number) => biomass / LBS_VALUE;
export const lbsToKg = (biomass: number) => biomass / KG_VALUE;
